import { useState } from 'react';
import { useScrapers } from '../../../api/queries';
import { useBulkScraperAction, useSetAllIntervals } from '../../../api/mutations';
import { DangerButton } from '../../../components/DangerButton';
import { Field } from '../../../components/Field';
import { Ic } from '../../../components/Ic';
import { INTERVALS } from '../../AddScraper/templates';
import { deriveScraperState } from '../../../lib/scraperState';

/** Deliberately not on the Scrapers toolbar: these hit every scraper at once,
 *  so they live behind a two-step confirm on a page you have to navigate to. */
export function BulkTab() {
  const { data: scrapers } = useScrapers();
  const bulk = useBulkScraperAction();
  const setAll = useSetAllIntervals();
  const [interval, setInterval] = useState(600);

  const total = scrapers?.length ?? 0;
  const paused = scrapers?.filter((s) => deriveScraperState(s) === 'paused').length ?? 0;
  const busy = bulk.isPending || setAll.isPending;

  return (
    <>
      <div className="pcard">
        <div className="head">
          <Ic.cmd className="ic" />
          <h3>Bulk actions</h3>
          <span className="spacer" />
          <span className="pill">
            {total} scrapers · {paused} paused
          </span>
        </div>
        <div className="body pad" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div className="muted" style={{ fontSize: 12.5 }}>
            These apply to every registered scraper at once.
          </div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <DangerButton
              className="btn success"
              disabled={busy}
              confirmLabel={`Start all ${total}?`}
              onConfirm={() => bulk.mutate('start-all')}
            >
              <Ic.play className="ico" /> Start all
            </DangerButton>
            <DangerButton
              className="btn danger"
              disabled={busy}
              confirmLabel={`Stop all ${total}?`}
              onConfirm={() => bulk.mutate('stop-all')}
            >
              <Ic.pause className="ico" /> Stop all
            </DangerButton>
            <DangerButton
              className="btn"
              disabled={busy}
              confirmLabel={`Restart all ${total}?`}
              onConfirm={() => bulk.mutate('restart-all')}
            >
              <Ic.refresh className="ico" /> Restart all
            </DangerButton>
          </div>
        </div>
      </div>

      <div className="pcard">
        <div className="head">
          <Ic.clock className="ic" />
          <h3>Set every interval</h3>
        </div>
        <div className="body pad" style={{ display: 'flex', gap: 10, alignItems: 'flex-end' }}>
          <Field label="New interval" style={{ minWidth: 200 }}>
            <select
              className="input"
              value={interval}
              onChange={(e) => setInterval(Number(e.target.value))}
            >
              {INTERVALS.map((i) => (
                <option key={i.value} value={i.value}>
                  Every {i.label}
                </option>
              ))}
            </select>
          </Field>
          <DangerButton
            className="btn danger"
            disabled={busy}
            confirmLabel="Overwrite all intervals?"
            onConfirm={() => setAll.mutate(interval)}
          >
            Apply to all {total}
          </DangerButton>
        </div>
      </div>
    </>
  );
}
